import { makePutRequest } from 'owa-ows-gateway';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';

const COMPLETE_TASK_URL: string = 'ows/api/v1.0/getstarted/tasks';

export function putGetStartedTask(identity: GetStartedTaskId): Promise<void> {
    return makePutRequest(
        `${COMPLETE_TASK_URL}/${identity}`,
        { id: identity },
        undefined,
        undefined,
        undefined,
        false
    );
}
